import { FC } from 'react';
import Grid from '@mui/material/Grid';
import contactImg from '../../media/contact.png';
import { Button, Typography, SvgIcon, Box } from '@mui/material';
import useTranslations from '../global/translation/hooks/translation';
import { LocationOn, Phone } from '@mui/icons-material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useTheme } from '@mui/material/styles';
import { useThemeContext } from '../global/ThemeContext';

const Contact: FC = () => {
  const { currentLanguage, translations } = useTranslations();
  const theme = useTheme();
  const { darkMode } = useThemeContext();

  return (
    <Grid
      my={6}
      py={{ xs: 6, md: 10 }}
      container
      justifyContent="center"
      alignItems="flex-start"
      sx={{
        bgcolor: darkMode ? '#121212' : '#FFFFFF',
        maxWidth: '1200px',
        mx: 'auto',
        px: { xs: 2, md: 4 },
      }}
    >
      <Grid item xs={12} mb={4}>
        <Typography variant="h4" fontWeight={300} sx={{ color: darkMode ? '#FFFFFF' : '#000000', letterSpacing: '-0.5px' }} textAlign="center">
          {translations.menuItems.contact[currentLanguage]}
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box sx={{ position: 'relative', mb: { xs: 3, md: 0 }, mr: { md: 2 } }}>
          {/* Top-right accent dots */}
          <Box
            sx={{
              position: 'absolute',
              top: '-8px',
              right: '20px',
              display: 'flex',
              gap: 1,
              zIndex: 2,
            }}
          >
            <Box sx={{ width: '6px', height: '6px', borderRadius: '50%', bgcolor: theme.palette.primary.main }} />
            <Box sx={{ width: '6px', height: '6px', borderRadius: '50%', bgcolor: theme.palette.primary.main }} />
            <Box sx={{ width: '6px', height: '6px', borderRadius: '50%', bgcolor: theme.palette.primary.main }} />
          </Box>
          <Box
            sx={{
              position: 'relative',
              paddingTop: '100%',
              borderRadius: '50%',
              overflow: 'hidden',
            }}
          >
            <img
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'contain' }}
              src={contactImg}
              alt="Contact location"
            />
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box
          sx={{
            p: { xs: 3, md: 4 },
            border: `1px solid ${darkMode ? '#333333' : '#EEEEEE'}`,
            borderRadius: '8px',
            bgcolor: darkMode ? '#1a1a1f' : '#F9F9F9',
            ml: { md: 2 },
          }}
        >
          <Button
            variant="text"
            fullWidth
            onClick={() => {
              window.open(
                'https://www.google.com/maps/dir//Urban+Equestrian,+Koszary/@51.1245855,21.1794487,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x47186ddde34b675b:0xed82cb2b23b6e247!2m2!1d21.2494807!2d51.1245984',
              );
            }}
            startIcon={<LocationOn sx={{ color: theme.palette.primary.main }} />}
            sx={{ color: darkMode ? '#FFFFFF' : '#000000', justifyContent: 'flex-start', textTransform: 'none', fontWeight: 400, mb: 2 }}
          >
            Koszary 8b, 27-100, Iłza
          </Button>
          <Button
            variant="text"
            fullWidth
            onClick={() => window.open('tel:729883891', '_self')}
            startIcon={<Phone sx={{ color: theme.palette.primary.main }} />}
            sx={{ color: darkMode ? '#FFFFFF' : '#000000', mb: 2, justifyContent: 'flex-start', textTransform: 'none', fontWeight: 400 }}
          >
            (+48) 729 883 891
          </Button>
          <Button
            variant="text"
            fullWidth
            onClick={() => window.open('https://www.facebook.com/profile.php?id=100063462341954')}
            startIcon={<FacebookIcon sx={{ color: theme.palette.primary.main }} />}
            sx={{ color: darkMode ? '#FFFFFF' : '#000000', textTransform: 'none', fontWeight: 400, mb: 2, justifyContent: 'flex-start' }}
          >
            Facebook
          </Button>
          <Button
            variant="text"
            fullWidth
            onClick={() => window.open('https://www.instagram.com/urbanequestrian_pl/?locale=pl&hl=am-et')}
            startIcon={<InstagramIcon sx={{ color: theme.palette.primary.main }} />}
            sx={{ color: darkMode ? '#FFFFFF' : '#000000', textTransform: 'none', fontWeight: 400, mb: 2, justifyContent: 'flex-start' }}
          >
            Instagram
          </Button>
          <Button
            variant="text"
            fullWidth
            onClick={() => window.open('https://www.tiktok.com/@urban.equestrian')}
            startIcon={
              <SvgIcon>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill={theme.palette.primary.main}>
                  <path d="M41.5 15.5c-3.2 0-5.8-2.6-5.8-5.8V6.5c0-0.6-0.4-1-1-1h-4.2c-0.6 0-1 0.4-1 1v25.2c0 3.2-2.6 5.8-5.8 5.8s-5.8-2.6-5.8-5.8 2.6-5.8 5.8-5.8c0.6 0 1-0.4 1-1v-4.2c0-0.6-0.4-1-1-1-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11v-9.6c1.7 1 3.7 1.6 5.8 1.6 0.6 0 1-0.4 1-1v-4.2c0-0.6-0.4-1-1-1z" />
                </svg>
              </SvgIcon>
            }
            sx={{ color: darkMode ? '#FFFFFF' : '#000000', textTransform: 'none', fontWeight: 400, justifyContent: 'flex-start' }}
          >
            TikTok
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Contact;
